import { render, staticRenderFns } from "./index-mobile.vue?vue&type=template&id=138ae1e5&scoped=true&lang=pug&"
import script from "./index-mobile.vue?vue&type=script&lang=js&"
export * from "./index-mobile.vue?vue&type=script&lang=js&"
import style0 from "./index-mobile.vue?vue&type=style&index=0&id=138ae1e5&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138ae1e5",
  null
  
)

export default component.exports